import React, { createContext, ReactNode } from 'react';

export const PageTranslationContext = createContext<Record<string, string>>({});

export const ContentfulTranslationsProvider = ({
  customTranslations,
  children,
}: {
  customTranslations: Record<string, string>;
  children: ReactNode;
}) => (
  <PageTranslationContext.Provider value={customTranslations}>
    {children}
  </PageTranslationContext.Provider>
);
